import React from 'react';

import './styles.scss';

const Loading = () => (
    <div className="loader-container">
        <div className="clock-loader"></div>
    </div>
);

export default Loading;
